module.exports = __webpack_public_path__ + "static/media/PDF6.1fdf0935.pdf";